<template>
    <b-container>
        <b-row>
            <b-col cols="2"></b-col>
            <b-col cols="8">
                <b-card class="mx-4" hidden>
                    <p>Прямая регистрация временно не доступна. Для доступа в личный кабинет необходимо зарегистрироваться в <a href="http://world-union.biz" target="_blank">Ассоциации Интернет-Предпринимателей</a> или в <a href="http://spooo.ru" target="_blank">Социальной сети Spooo.biz</a>, после чего авторизоваться с полученными логином/паролем в Profi-Bank</p>
                </b-card>
                <div class="card mx-4">
                    <div class="card-body p-4">
                        <form @submit.prevent="startRegistration" autocomplete="on">
                            <h1>Регистрация</h1>
                            <p class="text-muted">Укажите свои имя и email-адрес</p>

                            <b-form-group class="mb-0">
                                <div class="input-group">
                                    <span class="input-group-addon"><i class="icon-user"></i></span>
                                    <input type="text" class="form-control" :class="{'is-invalid': validationErrors.firstname, 'is-valid': isFormSubmitted && !validationErrors.firstname}" placeholder="Имя" v-model="registration.firstname">
                                </div>
                                <ul class="list-unstyled form-text text-danger mb-0" style="margin-left: 40px;" :class="{'d-none': !validationErrors.firstname}">
                                    <li v-for="error in validationErrors.firstname"><small>{{ error }}</small></li>
                                </ul>
                            </b-form-group>

                            <b-form-group class="mb-0">
                                <div class="input-group mt-3">
                                    <span class="input-group-addon"><i class="icon-user"></i></span>
                                    <input type="text" class="form-control" :class="{'is-invalid': validationErrors.lastname, 'is-valid': isFormSubmitted && !validationErrors.lastname}" placeholder="Фамилия" v-model="registration.lastname">
                                </div>
                                <ul class="list-unstyled form-text text-danger mb-0" style="margin-left: 40px;" :class="{'d-none': !validationErrors.lastname}">
                                    <li v-for="error in validationErrors.lastname"><small>{{ error }}</small></li>
                                </ul>
                            </b-form-group>

                            <b-form-group class="mb-0">
                                <div class="input-group mt-3">
                                    <span class="input-group-addon">@</span>
                                    <input type="email" class="form-control" :class="{'is-invalid': validationErrors.email, 'is-valid': isFormSubmitted && !validationErrors.email}" placeholder="E-Mail" v-model="registration.email">
                                </div>
                                <ul class="list-unstyled form-text text-danger mb-0" style="margin-left: 40px;" :class="{'d-none': !validationErrors.email}">
                                    <li v-for="error in validationErrors.email"><small>{{ error }}</small></li>
                                </ul>
                            </b-form-group>


                            <p class="text-danger small mt-3">
                                <small>При регистрации Вы автоматически подтверждаете свое <a href="#agreement" v-b-modal.agreement @click.prevent class="text-danger">согласие на&nbsp;обработку персональных данных</a>.</small>
                            </p>

                            <button type="submit" class="btn btn-block btn-primary" :disabled="!isRegistrationFormValid || isProcessing">Продолжить</button>
                        </form>

                        <b-modal id="agreement" title="Согласие на обработку персональных данных" size="lg" :ok-only="true">
                            <p>В соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных», я свободно, своей волей и в своем интересе даю согласие на осуществление «Profi Bank» (далее – Банк), обработки указанных в настоящем обращении моих персональных данных (сбора, записи, систематизации, накопления, хранения, уточнения (обновления, изменения), извлечения, использования, передачи, обезличивания, блокирования и уничтожения) с использованием/без использования средств автоматизации в целях обработки настоящего электронного обращения и направления/ предоставления ответа.</p>
                            <p>Согласие предоставляется с момента оформления настоящего обращения и действительно в течение срока, предусмотренного действующим законодательством Российской Федерации.</p>
                            <p>Я уведомлен(-на), что согласие на обработку персональных данных может быть отозвано в соответствии с ч. 2 ст. 9 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных». В случае отзыва согласия на обработку персональных данных Банк вправе продолжить обработку персональных данных без моего согласия при наличии оснований, указанных в п. 2-11 ч. 1 ст. 6, ч. 2 ст. 10, ч. 2 ст. 11 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».</p>
                            <p>Согласен(-на) с тем, что Банк в целях уточнения информации, содержащейся в обращении, и информирования о ходе рассмотрения настоящего обращения может использовать сведения, содержащиеся в настоящем электронном обращении.</p>
                            <p>Банк доводит Вашего сведения, что электронные обращения, направленные через сеть Интернет, передаются по незащищенным каналам связи. Банк не несет ответственности за сохранение конфиденциальности данных при их передаче через сеть Интернет.</p>
                        </b-modal>
                    </div>
                </div>

                <b-modal title="Ошибка" v-model="isRegistrationError" :ok-only="true" class="modal-danger" >
                    <div class="my-4" v-html="registrationErrorMessage"></div>
                </b-modal>
                <b-modal title="Сообщение" v-model="isRegistrationSuccess" :ok-only="true" ok-variant="success" class="modal-success">
                    <div class="my-4" v-html="registrationSuccessMessage"></div>
                </b-modal>
            </b-col>
            <b-col cols="2"></b-col>
        </b-row>
        <b-row>
            <b-col class="text-center">
                <b-link :to="{name: 'AuthLogin'}" class="btn btn-primary">Авторизация</b-link>
                <b-link :to="{name: 'Frontend'}" class="btn btn-primary">На главную</b-link>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: 'Register',
        data () {
            return {
                registration: {
                    lastname: '',
                    firstname: '',
                    email: ''
                },
                isFormSubmitted: false,
                isRegistrationError: false,
                registrationErrorMessage: '',
                validationErrors: {
                    firstname: false,
                    lastname: false,
                    email: false
                },

                isRegistrationSuccess: false,
                registrationSuccessMessage: '',

                isProcessing: false
            }
        },
        computed: {
            isRegistrationFormValid () {
                return this.registration.lastname && this.registration.firstname && this.isEmailValid
            },
            isEmailValid () {
                let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return re.test(this.registration.email)
            }
        },
        methods: {
            startRegistration () {
                this.isFormSubmitted = true

                this.registrationErrorMessage = ''
                this.isRegistrationError = false
                this.validationErrors = {
                    firstname: false,
                    lastname: false,
                    email: false
                }

                this.isProcessing = true

                this.axios.post('/auth/registration/start', this.registration)
                    .then(response => {
                        if (response.data.hasOwnProperty('message')) {
                            this.isRegistrationSuccess = true
                            this.registrationSuccessMessage = response.data.message
                        }

                        this.isProcessing = false
                    })
                    .catch(error => {
                        let response = error.response.data
                        if (response.hasOwnProperty('message')) {
                            this.registrationErrorMessage = response.message
                            this.isRegistrationError = true
                        }

                        this.isProcessing = false

                        Object.keys(response.errors).map(field => {
                            let fieldErrors = response.errors[field]
                            this.validationErrors[field] = fieldErrors
                            console.log(fieldErrors)
                        })
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Registration.vue?3c80dc1a